import React from "react";

export const Settings = () => {
  return <h1>Settings</h1>;
};
